<template>
    <v-card>
        <v-card-title class="headline grey darken-4">
            <v-icon left color="primary">mdi-cash-minus</v-icon>
            Retirada de caixa
            <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text>
            <MoneyInput class="my-4" v-model="withdrawal.amount" label="Valor do Suprimento"
                @keydown.enter="register()" />
        </v-card-text>
    </v-card>
</template>


<script>
    import { mapActions, mapState } from "vuex";
    export default {
        data() {
            return {

                withdrawal: {
                    amount: 0,
                    remark: "Retirada",
                },
            };
        },
        methods: {
            ...mapActions("withdrawal", ["storeWithdrawal"]),
            ...mapActions("cashier", ["activeCashier"]),

            register() {
                this.storeWithdrawal(this.withdrawal).then(() => {

                })
                this.$emit('close-dialog');
            },
        },

        computed: {
            ...mapState("cashier", ["cashier"]),
        },
    };
</script>